import CheckResultRuntime from 'packages/helpers/CheckResultRuntime';
import {ResultWithError} from 'packages/errors/errors';
import {post} from 'packages/rest/api';
import {SessionRaw, SessionRuntime} from '../model';

export type CreateUserRequest = {
    email?: string;
    password: string;
};

export async function CreateUserAPI({
    email,
    password,
    ...rest
}: CreateUserRequest): Promise<ResultWithError<SessionRaw>> {
    if (email === undefined) {
        throw new Error('Email required');
    }

    const res = await post({
        url: 'session',
        body: {
            new_email: email,
            new_password: password,
            ...rest,
        },
    });

    return CheckResultRuntime(SessionRuntime, res);
}
